import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "edit-users"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Voltar", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "double" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Sobrenome"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_8 = { class: "double" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "E-mail"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Senha"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nível do usuário"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_12 = ["onMousedown"]
const _hoisted_13 = ["onMousedown"]
const _hoisted_14 = { class: "spacing" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Status"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_16 = {
  class: "stats",
  for: "stats"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_18 = ["disabled"]

import { onMounted, ref, computed } from 'vue'
import MySelect from '@/components/select/MySelect.vue'
import FileUploader from '@/components/input/FileUploader.vue'
import { useAxios } from '@/api/axios'
import { AxiosResponse } from 'axios'
import RoleModel from '@/models/RoleModel'
import { UserModel } from '@/models/UserModel'
import { OrganizationModel } from '@/models/OrganizationModel'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import { toast } from 'vue3-toastify'
import { user } from '@/global/states/GlobalState'
import { TenantSectorEnum } from '@/enums/Tenants/TenantSectorEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowUserView',
  props: {
    id: {},
    user: {}
  },
  setup(__props: any) {

const props = __props
const axios = useAxios()
const isChamber = computed(() => user.value.tenant?.sector === TenantSectorEnum.CHAMBER)
const payload = ref<Partial<UserModel>>(props.user ? props.user : { roles: [], password: '' })
const roles = ref<RoleModel[]>()
const organizations = ref<OrganizationModel[]>()
const documentFiles = ref<File[]>([])
const isUpdatingUser = ref(false)
const allowedRoles = computed(() => {
  return roles.value?.filter((role) => role.name == 'Super Admin' || role.name == 'Presidente' ? user.value?.hasRoles!(['Super Admin']) || user.value?.hasRoles!(['Presidente']) : true)
})
const allowedOrganizations = computed(() => {
  return organizations.value?.filter((org) => org.id != user.value.organization_id ? user.value?.hasRoles!(['Super Admin']) || user.value?.hasRoles!(['Presidente']) : true)
})

onMounted(() => {
  axios.get('/api/roles')
    .then((res: AxiosResponse<RoleModel[]>) => {
      roles.value = res.data
    })

  axios.get('/api/organizations')
    .then((res: AxiosResponse<OrganizationModel[]>) => {
      organizations.value = res.data
    })

  if (!payload.value.id) {
    axios.get(`/api/users/${props.id}`)
      .then((res: AxiosResponse<UserModel>) => {
        payload.value = { ...res.data, status: !!res.data.status }
      })
  }
})

function updateUser (): void {
  isUpdatingUser.value = true

  const formData = new FormData()
  formData.append('user_ids[0]', String(payload.value.id))
  formData.append('organization_id', String(payload.value.organization!.id))
  formData.append('roles[0]', payload.value.roles![0].name as string)
  formData.append('status', payload.value.status ? '1' : '0')
  formData.append('name', payload.value.name!)
  formData.append('last_name', payload.value.last_name!)
  formData.append('email', payload.value.email!)
  if (payload.value.password) {
    formData.append('password', payload.value.password)
  }

  axios.put('/api/users', formData)
    .then(() => {
      toast.success('Usuário editado com sucesso')
    })
    .finally(() => isUpdatingUser.value = false)
}

return (_ctx: any,_cache: any) => {
  return (payload.value.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
          class: "back"
        }, _hoisted_4),
        _createElementVNode("section", _hoisted_5, [
          _createElementVNode("section", null, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Ex: João",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.name) = $event))
            }, null, 512), [
              [_vModelText, payload.value.name]
            ])
          ]),
          _createElementVNode("section", null, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Ex: da Silva",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.last_name) = $event))
            }, null, 512), [
              [_vModelText, payload.value.last_name]
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_8, [
          _createElementVNode("section", null, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Ex: João@gmail.com",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payload.value.email) = $event))
            }, null, 512), [
              [_vModelText, payload.value.email]
            ])
          ]),
          _createElementVNode("section", null, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Pelo menos 6 caracteres",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.password) = $event))
            }, null, 512), [
              [_vModelText, payload.value.password]
            ])
          ])
        ]),
        _createElementVNode("section", null, [
          _hoisted_11,
          (roles.value)
            ? (_openBlock(), _createBlock(MySelect, {
                key: 0,
                name: 'role',
                for: 'role',
                currentValue: payload.value.roles?.length ? payload.value.roles[0].name : null
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allowedRoles.value, (role, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      onMousedown: ($event: any) => {payload.value.roles![0] = role;}
                    }, _toDisplayString(role.name), 41, _hoisted_12))
                  }), 128))
                ]),
                _: 1
              }, 8, ["currentValue"]))
            : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h1", null, [
            _createElementVNode("strong", null, "A qual " + _toDisplayString(isChamber.value ? 'câmara' : 'setor') + " pertence", 1),
            _createTextVNode(" (obrigatório)")
          ]),
          (organizations.value)
            ? (_openBlock(), _createBlock(MySelect, {
                key: 0,
                name: 'organization',
                for: 'organization',
                currentValue: payload.value.organization ? payload.value.organization?.name : null
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allowedOrganizations.value, (organization, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      onMousedown: ($event: any) => {payload.value.organization = organization;}
                    }, _toDisplayString(organization.name), 41, _hoisted_13))
                  }), 128))
                ]),
                _: 1
              }, 8, ["currentValue"]))
            : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
        ]),
        _createElementVNode("section", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("label", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              name: "stats",
              id: "stats",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((payload.value.status) = $event))
            }, null, 512), [
              [_vModelCheckbox, payload.value.status]
            ]),
            _hoisted_17
          ])
        ]),
        _createElementVNode("nav", null, [
          (!isUpdatingUser.value)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "button",
                value: "Salvar",
                disabled: !payload.value.name || !payload.value.last_name || !payload.value.email || (payload.value.password && payload.value.password?.length < 6) || !payload.value.roles!.length || !payload.value.organization,
                onClick: updateUser
              }, null, 8, _hoisted_18))
            : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                key: 1,
                height: 60,
                maxWidth: 464
              })),
          _createElementVNode("input", {
            type: "button",
            value: "Cancelar",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({ name: 'admin.users.manage' })))
          })
        ])
      ]))
    : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
}
}

})